import { AppNav } from "@/components/AppNav";
import { Overline } from "@/components/dash/primitives";
import { Sparkles } from "lucide-react";

const ITEMS = [
  { t: "Supplier & carrier register", d: "Central directory of carriers, forwarders and rates with contract expiry tracking." },
  { t: "RFQ & tender management", d: "Issue rate requests, compare bids side-by-side and award lanes." },
  { t: "Contract & allocation commitments", d: "Track MQC/MVC commitments against actual bookings to avoid dead-freight." },
  { t: "Accruals & spend analytics", d: "Roll invoice-audit variances into monthly spend and savings dashboards." },
];

export default function Procurement() {
  return (
    <div className="min-h-screen bg-background">
      <AppNav />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10" data-testid="procurement-page">
        <Overline>Operations workspace</Overline>
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 mt-3">Procurement</h1>
        <p className="text-slate-600 mt-3 max-w-3xl leading-relaxed">
          The procurement workspace builds on the allocation and invoice-audit data. Below is the planned roadmap — tell us which to prioritise.
        </p>
        <div className="grid gap-4 md:grid-cols-2 mt-10">
          {ITEMS.map((it) => (
            <div key={it.t} className="bg-white border border-slate-200 rounded-xl p-5">
              <div className="flex items-center gap-2 text-primary">
                <Sparkles className="w-4 h-4" />
                <span className="text-[11px] uppercase tracking-wider font-num text-slate-400">Coming soon</span>
              </div>
              <h3 className="font-display font-semibold text-slate-900 mt-2">{it.t}</h3>
              <p className="text-sm text-slate-500 mt-1">{it.d}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
